import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Typography, Grid, useMediaQuery } from "@material-ui/core"
import { FormattedMessage } from "react-intl"
import RecommendImageLarge from "assets/images/RecommendImageLarge.png"
import RecommendImageSmall from "assets/images/RecommendImageSmall.png"

const useStyle = makeStyles(theme => ({
  container: {
    width: "100%",
    margin: "auto",
    paddingTop: "3px",
    paddingBottom: "15px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  recommendImage: {
    width: "100%",
    maxWidth: "345px",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "600px",
    },
  },
  description: {
    fontSize: "14px",
    fontWeight: 300,
    color: "#333333",
    lineHeight: "24px",
    paddingTop: "15px",
    [theme.breakpoints.down("xs")]: {
      lineHeight: "15px",
    },
  },
}))

const TopContents = ({ descriptionId }) => {
  const classes = useStyle()
  const isTabletPC = useMediaQuery("(min-width:1280px)")

  return (
    <Grid container className={classes.container}>
      <img
        src={isTabletPC ? RecommendImageLarge : RecommendImageSmall}
        alt="recommendImage"
        className={classes.recommendImage}
      />
      {descriptionId && (
        <Grid item>
          <Typography className={classes.description} id="contentsSubTitle">
            <FormattedMessage
              id={descriptionId}
              values={{ linebreak: <br /> }}
            />
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default TopContents
